import React from "react";
import "./NewsDetail.scss";
import ReactPlayer from 'react-player'
import {MDBBox} from "mdbreact";
import BottomNav from "../../component/BottomNav/BottomNav";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import AllNewsQuery from "../../queries/AllNewsQuery";
import Loading from "../../component/Loading";
import ReactTimeAgo from 'react-time-ago'
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";
import {Link} from "react-router-dom";
import {assetUrl} from "../../serviceApi";

const Clock = assetUrl+"images/clock.svg";


class NewsDetail extends React.Component {
	state = {
		newsId: "",
		newsData: {},
		loading: false
	}

	componentDidMount() {
		this.setState({
			newsId: this.props.match.params.id
		}, () => {
			this.getNewsDetail();
		})

	}

	getNewsDetail = () => {
		let variables = {
			id: this.state.newsId
		}
		this.updateLoading(true);
		fetchQuery(environment, AllNewsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.allNews !== null && response.allNews.edges.length > 0) {
					this.setState({
						newsData: response.allNews.edges[0].node
					})
					if(document.querySelector("#newsContent"))
					document.querySelector("#newsContent").innerHTML = response.allNews.edges[0].node.newsContent
				} else {
					this.setState({
						newsData: {}
					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					newsData: {}
				})
			});
	}

	updateLoading = (value) => {
		this.setState({
			loading: value
		});
	}
	redirectToOtherPage = (link) => {
		return <Link to={link} target='_blank'/>
	}


	render() {
		const {newsData} = this.state;
		return (
			<Loading loading={this.state.loading}>
				<div className={"news-detail-component"}>
					<TopNavSubpage heading={"News"} wallet={false} notify={false}/>
					<div className={"p-4"}>
						{newsData.featuredVideos !== null && newsData.featuredVideos &&
						<div className={"video-section mb-4"}>
							<ReactPlayer url={newsData.featuredVideos} width={"100%"} height={"200px"} controls={true}/>
						</div>
						}
						{newsData.featuredImage && <div className={"w-100 mb-3"}>

							{/*<Hero id='hero-1' show={true}>*/}
							<img src={newsData.featuredImage} alt={'alt'} className={"image"}/>
							{/*</Hero>*/}

						</div>}
						<div className={"mb-3"}>
							<a href={newsData.link ? newsData.link : "#"}
							   className={"news-title"} style={{marginBottom: "16px"}}>{newsData.shortDescription}</a>
						</div>

						{/*<div className={"mb-3"}>*/}
						{/*	<a href={newsData.link} target={"_blank"}>{}</a>*/}
						{/*</div>*/}
						{newsData.newsContent &&
							<div id={"newsContent"} className={'content text-justify mb-3'}>

								{/*{(newsData.newsContent).slice(1,((newsData.newsContent).length-1))}*/}

								{/*Crowds watched solemnly as the body of Rep. John Lewis crossed the Edmund Pettus Bridge*/}
								{/*one final time, 55 years after the civil rights icon marched for peace and was met with*/}
								{/*brutality in Selma, Alabama.*/}

								{/*Body bearers from the U.S. armed forces placed the late Georgia congressman and civil*/}
								{/*rights icon onto a horse-drawn caisson Sunday at the Brown Chapel African Methodist*/}
								{/*Episcopal Church.*/}
							</div>
						}
						<div className={"d-flex align-items-center"}>
							<img src={Clock} alt={"Clock"} className={"img-fluid"}/>
							<div className={"mb-0 news-time mx-1"}>
								<ReactTimeAgo date={newsData.created ? newsData.created : new Date()} locale="en-US"/>

							</div>
							<hr className={"news-divider"}/>
							<p className={"news-description my-0"}>
								{newsData.source}
							</p>
							{/*<div className={"vertical-line"}/>*/}
							{/*<p className={"news-author mb-0 mx-2"}>By Caroline Casey</p>*/}
						</div>
					</div>

					<br/>
					<br/>
					<br/>
					<MDBBox className="bottom-navbar">
						<BottomNav/>
					</MDBBox>
				</div>
			</Loading>
		);
	}
}

export default NewsDetail;